import { gql, useQuery } from '@apollo/client';
import { Outlet } from 'react-router-dom';
import { useParams } from 'react-router';
import { NOT_FOUND } from '../constants/errors';

const TeamAuthorizationQuery = gql`
  query Team($id: ID!) {
    team(id: $id) {
      id
      allowedActions {
        id
        canAccess
        canEdit
        canUpdateMembers
        canUpdateSettings
      }
    }
  }
`;

const TeamLayout = ({ action = 'canAccess' }) => {
  const { teamId } = useParams();
  const { loading, error, data } = useQuery(TeamAuthorizationQuery, {
    context: { priorityOp: true },
    variables: { id: teamId },
  });

  if (loading) return null;
  if (error || !data.team?.allowedActions?.[action]) throw new Error(NOT_FOUND);

  return <Outlet />;
};

export default TeamLayout;
